import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {OddsByWidgetController} from "../odds-by-widget.controller";

export class OddsByWidgetProps extends BaseModuleProps {
  controller: OddsByWidgetController;
  isPreview: Boolean;
  isCompetitorPage: Boolean;
  onSeeAllCLick: Function;
  entityType: String;
  entityId: Number;
}
